<template>
    <div class="content">
        <section>
            <div class="content-box">
                <HeaderBg :title="'4D'" :sub_title="'RESULT'" :desc="''" />

                <div class="text-center">
                    <h2 class="fw-bold mt-5">4D Result</h2>
                    <ResultCard v-for="item in paginatedResults" :key="item.id" :result="item" />
                </div>

                <div class="d-flex justify-content-center my-4 flex-wrap gap-2">
                    <PaginationButton v-model="page" :total-pages="totalPages" />
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import HeaderBg from './components/HeaderBg.vue'
import api from '@/axios'
import { asApiArray } from '@/utils/apiData'
import ResultCard from './components/CardResult.vue'
import PaginationButton from './components/Navigation.vue'

export default {
    name: 'QuickPick3DResult',
    components: {
        HeaderBg,
        ResultCard,
        PaginationButton
    },
    data() {
        return {
            allResults: [],
            page: 1,
            perPage: 2
        }
    },
    computed: {
        totalPages() {
            return Math.ceil(this.allResults.length / this.perPage)
        },
        paginatedResults() {
            const start = (this.page - 1) * this.perPage
            return this.allResults.slice(start, start + this.perPage)
        }
    },
    async created() {
        try {
            const response = await api.get('/results/4d')
            this.allResults = asApiArray(response.data)
        } catch (error) {
            console.error('Error fetching results:', error)
        }
    }
}
</script>

<style scoped></style>
